import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../../public/video/index/step-01.mp4';
import _imports_1 from '../../../../public/video/index/step-02.mp4';
import _imports_2 from '../../../../public/video/index/step-03.mp4';
import _imports_3 from '../../../../public/video/index/step-04.mp4';
const _withScopeId = n => (_pushScopeId("data-v-ba8c0e34"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "steps-container"
};
const _hoisted_2 = {
  class: "sticky-box"
};
const _hoisted_3 = {
  class: "sticky"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "num"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 0,
  name: "jiantou",
  size: "22"
};
const _hoisted_8 = {
  class: "steps-list"
};
const _hoisted_9 = {
  class: "steps-item-main"
};
const _hoisted_10 = {
  class: "steps-item-left"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  class: "steps-item-subtitle"
};
const _hoisted_14 = {
  class: "steps-item-right"
};
const _hoisted_15 = {
  key: 0,
  src: _imports_0,
  muted: "",
  autoplay: "",
  loop: ""
};
const _hoisted_16 = {
  key: 1,
  src: _imports_1,
  muted: "",
  autoplay: "",
  loop: ""
};
const _hoisted_17 = {
  key: 2,
  src: _imports_2,
  muted: "",
  autoplay: "",
  loop: ""
};
const _hoisted_18 = {
  key: 3,
  src: _imports_3,
  muted: "",
  autoplay: "",
  loop: ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Title = _resolveComponent("Title");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Title, {
    title: "Bring Your Creativity to Life <br>in 4 Easy Steps"
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeList, (v, j) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: j
    }, [_createElementVNode("li", {
      class: _normalizeClass({
        current: j === _ctx.currentType
      }),
      onClick: $event => _ctx.changeType(j)
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(j + 1), 1)]), _createElementVNode("div", {
      class: "title",
      innerHTML: v.title
    }, null, 8, _hoisted_6)], 10, _hoisted_4), j < _ctx.typeList.length - 1 ? (_openBlock(), _createElementBlock("iconpark-icon", _hoisted_7)) : _createCommentVNode("", true)], 64);
  }), 128))]), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "steps-item",
      key: index,
      ref_for: true,
      ref: `box${index}`
    }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
      src: item.img,
      alt: "",
      width: "234"
    }, null, 8, _hoisted_11), _createElementVNode("div", {
      class: "steps-item-title",
      innerHTML: item.title
    }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, _toDisplayString(item.subtitle), 1)]), _createElementVNode("div", _hoisted_14, [!index ? (_openBlock(), _createElementBlock("video", _hoisted_15)) : _createCommentVNode("", true), index === 1 ? (_openBlock(), _createElementBlock("video", _hoisted_16)) : _createCommentVNode("", true), index === 2 ? (_openBlock(), _createElementBlock("video", _hoisted_17)) : _createCommentVNode("", true), index === 3 ? (_openBlock(), _createElementBlock("video", _hoisted_18)) : _createCommentVNode("", true)])])]);
  }), 128))])])]);
}